/* @flow strict */

import * as React from 'react';
import QuestionsForm from '../registrationInfoForm/questionsForm';
import RegistrationForm from '../registrationInfoForm/registrationForm';
import BirthdayInput from '../registrationInfoForm/components/birthdayInput';
import _ from 'lodash';
import '../registrationInfoForm/registrationInfoForm.scss';

type PropType = {
  buyCart: [],
  registrationInfo: {
    additionalInfo?: {} | []
  },
  eventDetail: {
    questions: [],
    skip_collect_attendee_information: boolean,
    need_collect_demographic_data: boolean,
    need_collect_full_birth_day: boolean
  },
  formSubmited: boolean,
  setInitialRegistrationForm: () => void,
  onAdditionalInfoChange: () => void,
  onRegistrationInfoChange: () => void,
  onTicketQuestionChange: () => void
};

export const StepRegistration = (props: PropType): React.Element<'div'> => {
  const {
    buyCart,
    registrationInfo,
    eventDetail,
    formSubmited,
    onAdditionalInfoChange,
    onRegistrationInfoChange,
    onTicketQuestionChange,
    setInitialRegistrationForm
  } = props;

  React.useEffect(() => {
    initRegistrationForm();
  }, []);

  const splitCartItemsById = (items: []): [] => {
    return items.reduce((res: {}, curr: {}): {} => {
      if (res[curr.id]) {
        res[curr.id].push(curr);
      } else {
        Object.assign(res, { [curr.id]: [curr] });
      }
      return res;
    }, {});
  };

  const splittedCartItems = splitCartItemsById(buyCart);

  const initRegistrationForm = () => {
    const ticketsInfo = [];
    const initialPurchaserQuestions = [];

    Object.entries(splittedCartItems).map((el: []): [] => {
      return (
        el[1].map((ticket: {}, index: number): React.Element<'div'> => {
          const initialAttendeeQuestions = [];

          eventDetail.questions.map((question: {}) => {
            if (question.applied_to_ticket_id.includes(ticket.id) && question.ask_to === 'Attendee') {
              initialAttendeeQuestions.push({
                id: question.id,
                ticketId: ticket.id,
                value: null,
                isRequired: question.is_required
              });
            }
            if (question.applied_to_ticket_id.includes(ticket.id) && question.ask_to === 'Purchaser') {
              initialPurchaserQuestions.push({
                  id: question.id,
                  value: null,
                  isRequired: question.is_required
              });
            }
          });
          if (!eventDetail.skip_collect_attendee_information || eventDetail.need_collect_demographic_data) {
            ticketsInfo.push({
              id: index + 1,
              ticketId: ticket.id,
              firstName: null,
              lastName: null,
              email: null,
              phone: null,
              questions: initialAttendeeQuestions,
              isRequired: true
            });
          }
        })
      );
    });

    const form = {
      ticketsInfo,
      additionalInfo: initialPurchaserQuestions
    };

    setInitialRegistrationForm(form);
  };

  const renderQuestions = (ticketId: string, askTo: string, ticketIndex: number): React.Element<'div'> => {
    if (!(!!_.size(eventDetail.questions))) return null;
    const questionsToRender = [];

    eventDetail.questions.map((question: {}) => {
      if (question.applied_to_ticket_id.includes(ticketId) && question.ask_to === askTo) {
        questionsToRender.push(question);
      }
    });

    return (
      <>
        {askTo === 'Purchaser' && !!_.size(questionsToRender) &&
          <div className='sparxo-checkout-registration-info-form_title'>Additional info</div>
        }
        {_.get(registrationInfo, 'additionalInfo', false) &&
          <QuestionsForm
            questions={questionsToRender}
            formState={registrationInfo.additionalInfo}
            formSubmited={formSubmited}
            handleChange={(questionInfo: {}): void => {
              if (askTo === 'Purchaser') {
                return onAdditionalInfoChange(questionInfo);
              }
              return onTicketQuestionChange(questionInfo, ticketId, ticketIndex);
            }}
          />
        }
      </>
    );
  };

  return (
    <div className='sparxo-checkout-registration-info-form_container'>

      <div className='sparxo-checkout-registration-info-form_title'>Guest info</div>
      {Object.entries(splittedCartItems).map((el: []): [] => {
          return (
            el[1].map((ticket: {}, index: number): React.Element<'div'> => {
              return (
                <div key={index}>
                  <div className='sparxo-checkout-registration-info-form_ticketTitle'>
                    {`Guest ${index + 1}: ${ticket.name} `}
                  </div>
                  {(!eventDetail.skip_collect_attendee_information || eventDetail.need_collect_demographic_data) &&
                    <RegistrationForm
                      buyCart={buyCart}
                      formSubmited={formSubmited}
                      onChange={(e: {}): void => onRegistrationInfoChange(e, ticket.id, index)}
                    />
                  }
                  {eventDetail.need_collect_demographic_data &&
                    <div className='sparxo-checkout-registration-info-form_inputContainer'>
                      <div className='sparxo-checkout-registration-info-form_inputCaption'>Birthday</div>
                       <BirthdayInput
                         withYear={eventDetail.need_collect_full_birth_day}
                         onChange={(e: {}): void => onRegistrationInfoChange(e, ticket.id, index)}
                       />
                    </div>
                  }
                  {renderQuestions(ticket.id, 'Attendee', index)}
                  {index === el[1].length - 1 &&
                    renderQuestions(ticket.id, 'Purchaser')
                  }
                </div>
              );
            })
          );
        })
      }
    </div >
  );
};
